module.exports = __webpack_public_path__ + "static/media/chart-growth-alt.e3fae88e.svg";